module.exports = __webpack_public_path__ + "media/img/download_app_store_white@2x-f6a71624.png";